var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1625 3.8165L12.1531 3.82816L4.45134 13.6653C4.35978 13.7823 4.30991 13.9263 4.30991 14.0739L4.30991 16.8447C4.30991 17.0507 4.40685 17.2428 4.57133 17.363C4.7358 17.4831 4.94845 17.517 5.14478 17.4544L7.77511 16.6159C7.90271 16.5752 8.01542 16.4962 8.0979 16.3897L15.7024 6.56636C16.5298 5.54799 16.2243 4.13718 15.2919 3.41716C14.3238 2.66965 12.9809 2.81803 12.1625 3.8165Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3017 13.1839C3.97326 13.3339 3.82281 13.7206 3.96567 14.0477C4.10853 14.3747 4.4906 14.5182 4.81904 14.3682L4.3017 13.1839ZM7.34954 16.3025C7.29142 16.6586 7.53081 16.9889 7.88423 17.0403C8.23765 17.0916 8.57127 16.8446 8.62939 16.4885L7.34954 16.3025ZM4.81904 14.3682C6.21455 13.7309 7.59732 14.7843 7.34954 16.3025L8.62939 16.4885C9.04335 13.952 6.64218 12.115 4.3017 13.1839L4.81904 14.3682Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPencil);
export default __webpack_public_path__ + "static/media/img_pencil.8bd29886d23482e0b5b3b720ea1e0094.svg";
export { ForwardRef as ReactComponent };